import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { VISION_MONITOR_QUERY_KEY } from './useGetVisionMonitorProducts';

import VisionMonitorService from '@/services/VisionMonitorService';

export function useVisionMonitorActions() {
  const queryClient = useQueryClient();

  const onSettled = () =>
    queryClient.invalidateQueries({ queryKey: VISION_MONITOR_QUERY_KEY });

  const reread = useMutation({
    mutationFn: (catalogIds: number[]) =>
      VisionMonitorService.rereadProducts(catalogIds),
    onSuccess: (_, catalogIds) =>
      toast.success(
        `${catalogIds.length} product(s) queued for a new Vision read`,
      ),
    onError: () => toast.error('Could not queue the Vision re-read'),
    onSettled,
  });

  const regenerateCategory = useMutation({
    mutationFn: (catalogIds: number[]) =>
      VisionMonitorService.regenerateCategory(catalogIds),
    onSuccess: (_, catalogIds) =>
      toast.success(
        `${catalogIds.length} product(s) queued for a new Vision category name`,
      ),
    onError: () => toast.error('Could not queue the category regeneration'),
    onSettled,
  });

  return {
    reread: reread.mutateAsync,
    regenerateCategory: regenerateCategory.mutateAsync,
    isPending: reread.isPending || regenerateCategory.isPending,
  };
}
